/**
 * IMPORTAZIONE DEI CONTATTI RAPIDI (FILO-67) — la conferma dell'import, con la data di inizio dei
 * richiami: le scadenze dei task di follow-up si contano da lì, in giorni lavorativi. Chi importa
 * ogni sera dall'hotel indica il giorno del rientro in ufficio, così i task non risultano già
 * scaduti al ritorno.
 *
 * Una finestra apposita e non il ConfirmDialog condiviso, che porta solo un testo: qui c'è un
 * campo. La data si sceglie come giorno (yyyy-MM-dd); come istante la fa chi chiama l'API.
 */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';

/** Oggi come yyyy-MM-dd, nel fuso del browser: è il giorno che l'utente ha davanti. */
function today(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

interface RapidContactImportDialogProps {
  open: boolean;
  /** Quanti contatti si stanno per importare. */
  count: number;
  onCancel: () => void;
  /** @param callStartDate il giorno di inizio dei richiami, yyyy-MM-dd */
  onConfirm: (callStartDate: string) => void;
}

export function RapidContactImportDialog({ open, count, onCancel, onConfirm }: RapidContactImportDialogProps) {
  const { t } = useTranslation();
  const [callStartDate, setCallStartDate] = useState(today);

  // A ogni apertura si riparte da oggi: chi importa di nuovo il giorno dopo non deve ritrovarsi la
  // data di ieri senza accorgersene.
  useEffect(() => {
    if (open) setCallStartDate(today());
  }, [open]);

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>{t('rapidContact.importDialog.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('rapidContact.importConfirm', { count })}</DialogContentText>
        <TextField
          type="date"
          label={t('rapidContact.importDialog.callStartDate')}
          helperText={t('rapidContact.importDialog.callStartDateHint')}
          value={callStartDate}
          onChange={(e) => setCallStartDate(e.target.value)}
          fullWidth
          margin="normal"
          slotProps={{ inputLabel: { shrink: true } }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{t('common.cancel')}</Button>
        <Button variant="contained" disabled={!callStartDate} onClick={() => onConfirm(callStartDate)}>
          {t('rapidContact.import')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
